/**
 * supervisors.js
 */

import React from 'react';
import {
  useMediaQuery,
  IconButton,
  List
} from '@mui/material';
import { Types } from 'utils/constants';
import { UserContext } from 'contexts/user/user-context';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import DataGrid from 'components/data-grid';
import NameCell from './name-cell';
import RowMobile from './row-mobile';


export default function ManagedSupervisors(props) {
  const {
    data,
    onRemove,
  } = props;
  const { user } = React.useContext(UserContext);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });


  const superMenu = (superUser) => (
    <DropMenu
      id={`${superUser.id}-super-menu`}
      label={<IconButton size='small' data-testtype='menu-button'><Icon type='menu' /></IconButton>}
      items={[{
        id: 'remove',
        icon: 'delete',
        name: 'Remove ...',
        data: superUser,
        onSelect: () => onRemove(
          Types.Role.MANAGER, 
          user.id,
          superUser.id, {
            userType: 'Supervisor',
            text: `remove ${superUser.name} from you list of managed supervisors`
          }
        )
      }]}
    />
  );


  const columns = [{ 
    field: 'name',
    headerName: 'Name',
    width: 185,
    renderCell: (params) => <NameCell name={params.row.name} department={params.row.departmentName} />,
  }, {
    field: 'handlerCount',
    headerName: 'Handlers',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    cellClassName: 'simple-count-cell',
    valueGetter: (params) => params.row.handlers.length
  }, {
    field: 'numSupervisedSupervisors',
    headerName: 'Supervisors',
    headerAlign: 'center',
    align: 'center',
    width: 125,
    cellClassName: 'simple-count-cell',
  }, {
    field: 'menu',
    headerName: ' ',
    sortable: false,
    align: 'right',
    width: 42,
    minWidth: 42,
    renderCell: (params) => superMenu(params.row)
  }
];


  return (
    <>
      {/* MOBILE */}
      {isMobile &&
      <List>
        {data.filter(u => u.id !== user.id).map((u, i) => <RowMobile
          key={i}
          nameContent={<NameCell name={u.name} department={u.departmentName} />}
          menu={superMenu(u)}
        />)}
      </List>}

      {/* DESKTOP */}
      {!isMobile &&
      <DataGrid
        rows={data.filter(u => u.id !== user.id)}
        columns={columns}
        headerHeight={48}
        rowHeight={48}
        autoHeight
        disableColumnMenu
        disableRowSelectionOnClick
        hideFooter
        hideFooterSelectedRowCount
      />}
    </>
  );
}